// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"889":"e1795ae3","938":"446e7a9b"}[chunkId] + ".chunk.js";
};